/**
 * Checkout routes
 * Routes used in the checkout flow
 */

export const CHECKOUT_ROUTES = {
  BASE: '/checkout',
  DELIVERY: '/checkout/delivery',
  DELIVERY_COLLECTIONS: '/checkout/delivery/collections',
  PAYMENT: '/checkout/payment',
  PAYMENT_ERROR: '/checkout/payment/error',
  CONFIRMATION: '/checkout/confirmation',
} as const;
